import { useState } from 'react';
import { faqItems } from '@/mocks/testimonials';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <p className="text-xs font-semibold uppercase tracking-widest text-secondary-600 mb-2 text-center whitespace-nowrap">/ FAQ</p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 text-center mb-3">
            Frequently Asked <span className="text-primary-500">Questions</span>
          </h2>
          <p className="text-foreground-500 text-sm text-center mb-10 max-w-md mx-auto">
            Everything you need to know about the AcBuy Spreadsheet — answered clearly and concisely.
          </p>

          <div className="flex flex-col gap-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(idx)}
                  className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                >
                  <h4 className="font-heading text-base md:text-lg font-semibold text-foreground-900 pr-4">
                    {item.question}
                  </h4>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-colors ${
                    openIndex === idx ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-400'
                  }`}>
                    <i className={`text-sm transition-transform duration-200 ${openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </div>
                </button>
                {openIndex === idx && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-foreground-600 text-sm leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: faqItems.map((item) => ({
                  '@type': 'Question',
                  name: item.question,
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: item.answer,
                  },
                })),
              }),
            }}
          />
        </div>
      </div>
    </section>
  );
}